import debugLog from '@/debug-log-script-name.js'
import handleAjaxResponse from '@/components/handle-ajax-response.js'

let logged = false

$(function() {
  $('body').on('bless', function(e) {
    const $target = $(e.target)
    const $forms = $target.is('form') ? $target : $target.find('form')
    $forms.each(function() {
      const $form = $(this)
      if ($form && !logged) {
        debugLog($target, 'ajax-form.js')
        logged = true
      }
      $form.on('submit', function(e) {
        // 01/10/2019 PF: data-ajax is only used in modals
        if ($form.attr('data-ajax')) {
          const url = $form.attr('action')
          const method = $form.attr('method')
          $.ajax({
            method: method,
            url: url,
            data: $form.serialize(),
            dataType: 'json',
          }).done(function(data) {
            handleAjaxResponse(data)
          })

          e.preventDefault()
        }
      })
    })
  })
})
